<template>
  <el-dialog
      :visible="true"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="agreeTitle"
      custom-class="theme-dialog dialog-body-0 agree-info-dialog"
      width="766px"
  >
    <template #title>
      <div class="break-all text-large">
        {{ agreeTitle }}
      </div>
    </template>
    <div class="px-6 overflow-hidden" ref="container">
      <div class="border-b border-solid border-border-gray py-3 ">
        <div class="overflow-auto" style="max-height: 360px">
          <div class="agree-content " v-html="option.contentText"></div>
        </div>
      </div>
      <div class="mt-2" v-if="needSignature">
        <div class="flex justify-between items-center">
          <span>请在下方矩形框内绘制签名</span>
          <el-button type="text" @click="clear">清空</el-button>
        </div>
        <div class="canvas-wrapper mt-2">
          <canvas ref="canvasRef" width="718" height="200"></canvas>
        </div>
      </div>
      <InfoSnapshot
          ref="infoSnapshot"
          :title="agreeTitle"
          :content="option.contentText"
          :signature-url="signatureUrl"
      />
    </div>
    <template #footer>
      <div>
        <el-button size="large" type="default" v-if="showDisagreeBtn" class="cancel-btn agree-btn" @click="onDisagree">
          {{
            disagreeBtnText
          }}
        </el-button>
        <el-button size="large" type="primary" class="agree-btn" :loading="loading" :disabled="minReadTime > 0" @click="agree">
          {{ agreeBtnText }}
          <template v-if="minReadTime > 0">
            （ {{ minReadTime }}秒后继续 ）
          </template>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import Signature from 'signature_pad'
import { Message } from 'dygc-ui'
import { dataURLToBlob } from 'dygc'
import InfoSnapshot from '@/components/overlay/InfoSnapshot.vue'

export default {
  name: 'AgreeInfo',
  components: { InfoSnapshot },
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      signature: null,
      minReadTime: 0,
      signatureUrl: null,
      loading: false
    }
  },
  computed: {
    agreeTitle() {
      return this.option.title || '知情同意书'
    },
    agreeBtnText() {
      return this.option.agreeBtnText || '同意并继续'
    },
    disagreeBtnText() {
      return this.option.disagreeBtnText || '不同意并退出'
    },
    showDisagreeBtn() {
      return this.option.showDisagreeBtn || false
    },
    needSignature() {
      return this.option.needSignature || false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    getSignatureUrl() {
      let signature = this.signature

      let dataURL = signature.toDataURL('image/png')
      let blob = dataURLToBlob(dataURL)
      const f = new File([blob], Date.now() + '.png')
      let fd = new FormData()
      fd.append('file', f)

      return fd
    },
    setContainerStyle(){
      const el = this.$refs.container
      el.style.maxHeight = el.clientHeight + 'px'
    },
    agree() {
      this.loading = true
      if (this.signature) {
        if (this.signature.isEmpty()) {
          this.loading = false
          Message.error('请签名')
        } else {
          const fd = this.getSignatureUrl()
          this.setContainerStyle()
          this.signatureUrl = this.signature.toDataURL('image/png')
          this.$nextTick(()=>{
            this.$refs.infoSnapshot.getSnapshot().then((snap)=>{
              this.$emit('confirm', fd,snap)
              this.loading = false
            }).catch(()=>{
              this.$emit('confirm', fd)
              this.loading = false
            })
          })
        }
      } else {
        this.setContainerStyle()
        this.$refs.infoSnapshot.getSnapshot().then((snap)=>{
          this.$emit('confirm',null, snap)
          this.loading = false
        }).catch(()=>{
          this.$emit('confirm')
          this.loading = false
        })
      }
    },
    onDisagree() {
      if (this.option.disagreeJump && /^http[s]?:\/\/.*/.test(this.option.disagreeJumpLink || '')) {
        window.location.href = this.option.disagreeJumpLink
      } else {
        // const newWindow = window.open('', '_self')
        // newWindow.close()
        this.$emit('cancel')
      }
    },
    init() {
      this.minReadTime = this.option.minReadTime || 0
      if (this.minReadTime > 0) {
        this.agreeTimer = setInterval(() => {
          this.minReadTime -= 1
          if (this.minReadTime <= 0) {
            clearInterval(this.agreeTimer)
          }
        }, 1000)
      }

      if (!this.needSignature) return
      let el = this.$refs.canvasRef
      let signature = this.signature = new Signature(el, {})

      this.$nextTick(() => {
        this.signature.clear()
        this.drawGrid('#ccc', 10, 10)
      })
    },
    drawGrid(color, stepx, stepy) {
      let canvas = this.$refs.canvasRef
      let context = canvas.getContext('2d')
      context.save()
      context.fillStyle = 'white'
      let cw = context.canvas.width
      let ch = context.canvas.height
      context.fillRect(0, 0, cw, ch)
      context.lineWidth = 0.5
      context.strokeStyle = color
      const fn = (x, y, lx, ly) => {
        context.beginPath()
        context.moveTo(x, y)
        context.lineTo(lx, ly)
        context.closePath()
        context.stroke()
      }
      for (let i = stepx; i < cw; i += stepx) {
        fn(i, 0, i, ch)
      }
      for (let j = stepy; j < ch; j += stepy) {
        fn(0, j, cw, j)
      }
      context.restore()
    },
    clear() {
      this.$nextTick(() => {
        this.signature.clear()
        this.drawGrid('#ccc', 10, 10)
      })
    }
  }
}
</script>
<style>
.agree-info-dialog {
  .el-dialog__body {

  }
}
</style>

<style lang="scss" scoped>
.canvas-wrapper {
  canvas {
    @apply border-t border-b border-solid border-border-gray;
  }

}

.cancel-btn {
  border-color: #d9d9d9;
  background-color: #d9d9d9;
  color: rgba(0, 0, 0, .65);
}

.agree-btn {
  min-width: 240px;
  border-radius: 2px;
}
</style>
